<template>
	<div class="container-profit">
		<div class="profit-wrap clearfix">
			<div class="profit-team profit-cube fl-l">
				<div class="profit-title">{{ team.title }}</div>
				<div class="profit-text">
					<p v-for="ct in team.content" :key="ct.text">
						<img :src="ct.icon" alt />
						<span>{{ ct.text }}</span>
					</p>
				</div>
				<div class="profit-button">
					<a href="/s/team">{{ team.btn }}</a>
				</div>
			</div>
			<div class="profit-school profit-cube fl-l">
				<div class="profit-title">{{ ents.title }}</div>
				<div class="profit-text">
					<p v-for="ct in ents.content" :key="ct.text">
						<img :src="ct.icon" alt />
						<span>{{ ct.text }}</span>
					</p>
				</div>
				<div class="profit-button">
					<a href="/s/enterprise">{{ ents.btn }}</a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import file from '../images/file.svg'
import people from '../images/people.svg'
import cloud from '../images/cloud.svg'
import team from '../images/team.svg'
import settings from '../images/settings.svg'
import develop from '../images/develop.svg'
import storage from '../images/storage.svg'
import mail from '../images/mail.svg'

export default {
	computed: {
		team() {
			return {
				title: this.getConstants('PRICING_NEW_VERSIONS_TEAM_TITLE'),
				content: [
					{
						text: this.getConstants('PRICING_NEW_VERSIONS_TEAM_TEXT1'),
						icon: file,
					},
					{
						text: this.getConstants('PRICING_NEW_VERSIONS_TEAM_TEXT2'),
						icon: people,
					},
					{
						text: this.getConstants('PRICING_NEW_VERSIONS_TEAM_TEXT3'),
						icon: cloud,
					},
					{
						text: this.getConstants('PRICING_NEW_VERSIONS_TEAM_TEXT4'),
						icon: team,
					},
				],
				btn: this.getConstants('PRICING_NEW_VERSIONS_TEAM_BUTTON'),
			}
		},
		ents() {
			return {
				title: this.getConstants('PRICING_NEW_VERSIONS_ENT_TITLE'),
				content: [
					{
						text: this.getConstants('PRICING_NEW_VERSIONS_ENT_TEXT1'),
						icon: settings,
					},
					{
						text: this.getConstants('PRICING_NEW_VERSIONS_ENT_TEXT2'),
						icon: storage,
					},
					{
						text: this.getConstants('PRICING_NEW_VERSIONS_ENT_TEXT3'),
						icon: develop,
					},
					{
						text: this.getConstants('PRICING_NEW_VERSIONS_ENT_TEXT4'),
						icon: mail,
					},
				],
				btn: this.getConstants('PRICING_NEW_VERSIONS_ENT_BUTTON'),
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.container-profit {
	background: #fff;
	.profit-wrap {
		width: 975px;
		margin: 0 auto;
	}
	padding-bottom: 50px;
	padding-top: 50px;
	min-width: 960px;
	justify-content: center;
	.profit-cube {
		width: 400px;
		height: 400px;
		border-radius: 8px;
		background-color: #ffffff;
	}
	.profit-cube .profit-title {
		text-indent: 48px;
		font-size: 24px;
		color: #299bff;
		line-height: 24px;
		padding-top: 44px;
	}
	.profit-cube .profit-text {
		padding-top: 20px;
		padding-bottom: 24px;
	}
	.profit-text p {
		position: relative;
		padding-left: 48px;
		line-height: 48px;
		font-size: 16px;
		text-indent: 48px;
		text-align: left;
	}
	.profit-text img {
		position: absolute;
		left: 48px;
		top: 12px;
		width: 24px;
		height: 24px;
	}
	.profit-button {
		margin-left: 48px;
		width: 240px;
		height: 38px;
		border-radius: 4px;
		border: solid 2px #299bff;
		text-align: center;
		cursor: pointer;
		&:hover {
			background: #299bff;
			a {
				color: #fff;
			}
		}
	}
	.profit-button a {
		display: block;
		font-size: 16px;
		line-height: 38px;
		color: #299bff;
		width: 100%;
	}
	.profit-school {
		margin-left: 175px;
	}
}
</style>
